import ms from 'ms';

import Module from '@/scripts/old/classes/Module';
import Countdown from '@/scripts/old/classes/Countdown';
import DECLS from '@/scripts/old/common/decls';
import { parseAttr, declOfNums } from '@/scripts/old/helpers/utils';

const NAMESPACE = 'data-inline-countdown';

class InlineCountdownsModule extends Module {
  constructor() {
    super(`[${NAMESPACE}]`);
  }

  initInstance(el) {
    let timestamp = parseAttr(el, NAMESPACE) || Date.now();

    if (typeof timestamp === 'string') {
      timestamp = Date.now() + ms(timestamp);
    }

    const countdown = new Countdown(timestamp, {
      onUpdate(offset) {
        // Month and days
        if (offset.months) {
          let str = `${offset.months} ${declOfNums(offset.months, DECLS.months)}`;
          if (offset.days) {
            str += ` ${offset.days} ${declOfNums(offset.days, DECLS.days)}`;
          }
          el.innerText = str;
         countdown.destroy();
          return;
        }

        // Days and hours
        if (!offset.months && offset.days) {
          let str = `${offset.days} ${declOfNums(offset.days, DECLS.days)}`;
          if (offset.hours) {
            str += ` ${offset.hours} ${declOfNums(offset.hours, DECLS.hours)}`;
          }
          el.innerText = str;
         countdown.destroy();
          return;
        }

        let str = `0${offset.hours}`.slice(-2);
        str += ':';
        str += `0${offset.minutes}`.slice(-2);
        str += ':';
        str += `0${offset.seconds}`.slice(-2);
        el.innerText = str;
      },
      onComplete() {},
    });

    countdown.start();

    this.instances.set(el, countdown);
  }

  destroyInstance(instance) {
    instance.destroy();
  }
}

export default new InlineCountdownsModule();
